import axios from 'axios'
var contratoNumero = '5107'
localStorage.setItem('contrato',contratoNumero)
export const http = axios.create({
  //baseURL: 'http://apppanterafood.com.br/DeliveryCenter/3/cardapio/',
  //baseURL: 'http://192.168.1.27/cardapio/',
  //baseURL: './', //LOCAL DA RAIZ
  baseURL: './php-deli',
  //baseURL: '../cardapio/', //SERVIDOR DA PASTA 3
  //baseURL: "./php-qrcode", //LOCAL DA PASTA 3
  contrato: "",
});

/* var url=window.location.hash
var query=''
var contrato =''
var contratoNumero =''

query = url.replace('#','').replace('?',"").replace('/',"").split("=")


if(!isNaN(parseInt(query[1])) && query[1] != undefined ){
  console.log(query[1],"teste")
  contratoNumero=query[1]
  localStorage.setItem('contrato',contratoNumero)
}else{
  contratoNumero = localStorage.getItem('contrato')
}

export const contratoNum=contratoNumero;
export const http = axios.create({
  //baseURL: 'http://apppanterafood.com.br/DeliveryCenter/3/cardapio/',
  //baseURL: 'http://192.168.1.27/cardapio/',
  //baseURL: '../', //LOCAL DA RAIZ
  //baseURL: './',
  baseURL: './php-deli',
  //baseURL: './php', //LOCAL DA PASTA 3
  params:{
    c:contratoNumero
  },
  contrato: ''
})

 */